import { api } from "@/api"

import { queryClient } from "@/queryClient"

export const createProductModifier = async (
  params: CreateUpdateProductModifierBody
) => {
  const { body } = await api.post<{ id: string }>(
    "/products/product-modifiers/",
    {
      body: params,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCT_MODIFIERS_QUERY_KEY],
  })
  return body
}
